import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import config from "../config";
import Office from "../entities/Ofiice";
import { useAuth } from "../context/Auth";

interface Props {
  defaultValue?: number;
  onChange?: (id: number) => void;
  disabled?: boolean;
  label?: string;
  endpoint?: string
}

const OfficeSelect = ({ defaultValue, onChange, disabled, label = "Office", endpoint = "GetOfficeList" }: Props) => {
  const [offices, setOffices] = useState<Office[]>([]);
  const [selected, setSelected] = useState<number | undefined>(defaultValue);
  const { fetchWithUser } = useAuth()

  useEffect(() => {
    const url = `${config.apiUrl}/CodeTable/${endpoint}`;
    fetchWithUser(url)
      .then((response) => response.json())
      .then((data) => setOffices(data));
  }, [endpoint, fetchWithUser]);

  return (
    <FormControl variant="outlined">
      <InputLabel>{label}</InputLabel>
      <Select
        value={selected}
        onChange={(e: any) => {
          const value = e.target.value;
          setSelected(value);
          onChange?.(value);
        }}
        label={label}
        disabled={disabled}
      >
        {offices.map((office: any) => (
          <MenuItem value={office.key}>{office.value}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default OfficeSelect;
